import { useQuery } from "@tanstack/react-query"
import { apiClient } from "../helpers/Axios"

export const useCart = () => {
    return useQuery({
        queryKey: ['cart'],
        queryFn: async () => {
            const res = await apiClient.get('/cart');
            return res.data
        },
        refetchOnWindowFocus: false
    })
}